module.exports = __webpack_public_path__ + "img/logo-color.9d2e7af1.png";